// #region Imports
import "./libs/polyfills/replaceWith";
import "core-js/stable";
import jQuery from "jquery";
import $ from "jquery";
import * as AjaxPost from "./modules/ajaxPost";
import * as Annotation from "./modules/document/annotation";
import * as AnchorLinkEnhancer from "./modules/ui/anchorLinkEnhancer";
import * as AutoComplete from "./modules/autoComplete";
import * as AutoLoadOnScroll from "./modules/navigation/autoLoadOnScroll";
import * as Bookmarker from "./modules/document/bookmarker";
import * as Watcher from "./modules/document/watcher";
import * as ButtonAreaState from "./modules/buttonAreaState";
import * as ButtonSidebar from "./modules/buttonSidebar";
import * as ButtonToggle from "./modules/buttonToggle";
import * as CookieConsent from "./modules/cookieConsent";
import * as DocumentSearch from "./modules/document/documentSearch";
import * as EnablePrint from "./modules/print/enablePrint";
import * as ExpandOnHover from "./modules/ui/expandOnHover";
import * as ExportNotes from "./modules/exportNotes";
import * as HideOnScroll from "./modules/hideOnScroll";
import * as HeroShortcut from "./modules/navigation/heroShortcuts";
import * as ImportNotes from "./modules/importNotes";
import * as IntelligentNavigator from "./modules/navigation/intelligentNavigator";
import * as LoadMore from "./modules/loadMore";
import * as Menu from "./modules/navigation/menu";
import * as ObjectFitFallback from "./modules/objectFitFallback";
import * as PrettifySelect from "./modules/ui/prettifySelect";
import * as PrintNotes from "./modules/print/printNotes";
import * as ScrollLocker from "./components/scrollLocker";
import * as ScrollToTop from "./components/scrollToTop";
import * as Tooltip from "./components/tooltip";
import * as Sidebar from "./modules/sidebar";
import * as StartpageHero from "./modules/startpageHero";
import * as SearchField from "./modules/search/searchfield";
import * as SearchFilter from "./modules/search/filter";
import * as SearchPagination from "./modules/search/pagination";
import * as SearchModule from "./modules/search/searchModule";
import * as SearchSort from "./modules/search/sort";
import * as SearchTabs from "./modules/search/tabs";
import * as SelectionBlocker from "./modules/ui/selectionBlocker";
import * as SimpleSlider from "./modules/ui/simpleSlider";
import * as StickyDocumentTools from "./modules/stickyDocumentTools";
import * as StopPropagation from "./modules/stopPropagation";
import * as SkipToContent from "./modules/skipToContent";
import * as SubjectPageFilter from "./modules/subjectpage-filter";
import * as SubmitChange from "./modules/submitChange";
import * as TeaserToggler from "./modules/ui/teaserToggler";
import * as ToggleTags from "./modules/toggleTags";
import * as TrackingHelper from "./modules/helpers/trackingHelper";
import * as TriggerProductFilter from "./modules/triggerProductFilter";
import * as VideoOverlay from "./modules/videoOverlay";
import * as SearchForm from "./components/searchForm";
import * as Tour from "./components/tour";
import { initialize as initializeBookmarkApp } from "./react-features/sidebar-bookmarks/bookmarkApp";
import { initialize as initializeCoverageApp } from "./react-features/sidebar-coverage/coverageApp";
import { initialize as initializeNotesApp } from "./react-features/sidebar-notes/notesApp";
import { initialize as initializeHeroBookmarkApp } from "./react-features/hero-bookmarks/bookmarkApp";
import { initialize as initializeHeroEducationApp } from "./react-features/hero-educations/educationApp";
import { initialize as initializeHeroNotesApp } from "./react-features/hero-notes/notesApp";
import * as ModalHandler from "./react-features/modal-handler/modalHandler";
import * as AiApp from "./react-features/aiApp";

import Glide, {
    Autoplay,
    Controls,
    Swipe,
    Breakpoints
} from "@glidejs/glide/dist/glide.modular.esm";
import { clickToExpand } from "./modules/clickToExpand";
import { initialize } from './components/scrollLocker';

// #endregion
const recalcViewportHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
};

const recalcViewportZoomLevels = () => {
    const obj = document.querySelector("meta[name=viewport]");
    if(obj){
   
        if(window.outerWidth > 960){
            if(window.devicePixelRatio >= 1.5){
                $("html").addClass("isZoomedIn");
            }            
        }else{
            $("html").removeClass("isZoomedIn");
        }

    }else{
        console.warn("not able to adjust zoomlevel");
    }
};

const formWithAnimatedArrowWrapper = document.querySelector('.teaser-startpage');

const formWithAnimatedArrowWrapperPosition = formWithAnimatedArrowWrapper
    ? window.scrollY + formWithAnimatedArrowWrapper.getBoundingClientRect().top
    : null;

const showHideFormArrowFromStart = () => {
    if (formWithAnimatedArrowWrapper && formWithAnimatedArrowWrapperPosition !== null) {
        const windowHeight = window.scrollY + window.innerHeight;
        if (formWithAnimatedArrowWrapperPosition < windowHeight) {
            formWithAnimatedArrowWrapper.className = "teaser__header teaser-startpage animated-arrow";
        }
    }
};

const showHideFormArrow = () => {
    if (formWithAnimatedArrowWrapper && formWithAnimatedArrowWrapperPosition !== null) {
        const windowHeight = window.innerHeight;
        const scrollPosition = window.scrollY + windowHeight;

        if (formWithAnimatedArrowWrapperPosition < (scrollPosition - 30)) {
            formWithAnimatedArrowWrapper.className = "teaser__header teaser-startpage animated-arrow";
            window.onscroll = null;
        } else {
            formWithAnimatedArrowWrapper.className = "teaser__header teaser-startpage";
        }
    }
};

jQuery(() => {
    AjaxPost.initialize();
    AnchorLinkEnhancer.initialize();
    Annotation.initialize();
    AutoLoadOnScroll.initialize();
    Bookmarker.initialize();
    Watcher.initialize();
    ButtonAreaState.initialize();
    CookieConsent.initialize();
    DocumentSearch.initialize();
    ExpandOnHover.initialize();
    LoadMore.initialize();
    ButtonSidebar.initialize();
    ButtonToggle.initialize();
    EnablePrint.initialize();
    ExportNotes.initialize();
    HeroShortcut.initialize();
    HideOnScroll.initialize();
    ImportNotes.initialize();
    IntelligentNavigator.initialize();
    Menu.initialize();
    ObjectFitFallback.initialize();
    PrettifySelect.initialize();
    PrintNotes.initialize();
    ScrollLocker.initialize();
    ScrollToTop.initialize();
    Sidebar.initialize();
    StartpageHero.initialize();
    SearchField.initialize();
    SearchFilter.initialize();
    SearchPagination.initialize();
    SearchModule.initialize();
    SearchSort.initialize();
    SearchTabs.initialize();
    SelectionBlocker.initialize();
    SimpleSlider.initialize();
    StickyDocumentTools.initialize();
    StopPropagation.initialize();
    SkipToContent.initialize();
    SubmitChange.initialize();
    SubjectPageFilter.initialize();
    TeaserToggler.initialize();
    ToggleTags.initialize();
    Tooltip.initialize();
    TrackingHelper.initialize();
    TriggerProductFilter.initialize();
    VideoOverlay.initialize();
    ModalHandler.initialize();
    SearchForm;
    AiApp.initialize();
    Tour.initialize();

    clickToExpand();

    initializeBookmarkApp();
    initializeCoverageApp();
    if (document.querySelector("#document-main")) {
        initializeNotesApp();
    }
    $("#personalmenubuttonOpen").on("click", () => {
        if ($("#document-main").length < 1) {
        initializeNotesApp();
    }
    })
    $("#mynotespinned").on("click", () => {
        if ($("#document-main").length < 1) {
        initializeNotesApp();
    }
    })
    initializeHeroBookmarkApp();
    initializeHeroEducationApp();
    initializeHeroNotesApp();

    // Kör alla anrop som registrerats före jQuery laddats
    if (typeof (window as any).q !== "undefined") {
        $.each((window as any).q, (_, f) => {
            f();
        });
    }

    // window.addEventListener("resize", recalcViewportHeight);
    window.addEventListener("resize", ()=>{ recalcViewportHeight(); recalcViewportZoomLevels()});
    recalcViewportHeight();
    recalcViewportZoomLevels();
    showHideFormArrowFromStart();
    window.addEventListener("scroll", () => { showHideFormArrow(); });

    Object.values(document.querySelectorAll(".slideshow")).map((x) => {
        new Glide(x, {
            autoplay: 8000,
            type: "carousel",
            classes: {
                direction: {
                    ltr: "slideshow--ltr",
                    rtl: "slideshow--rtl",
                },
                slider: "slideshow--slider",
                carousel: "slideshow--carousel",
                swipeable: "slideshow--swipeable",
                dragging: "slideshow--dragging",
                cloneSlide: "slideshow__slide--clone",
                activeNav: "slideshow__step--active",
                activeSlide: "slideshow__slide--active",
                disabledArrow: "slideshow__arrow--disabled",
            },
        }).mount({ Autoplay, Controls, Swipe });
    });

    window.addEventListener('load', () => {
        Object.values(document.querySelectorAll(".carousel-A")).forEach((x) => {
            const parent = x.closest('.component_content-list');
            const slideshowName = parent?.id;

            const steps = x.querySelectorAll('.slideshow__step');
            const slides = x.querySelectorAll('.slideshow__slide');
            const tags = x.querySelectorAll('.slideshow__tag');

            let startAt = 1;

            steps.forEach((step, index) => {
                if (step.classList.contains('is-start')) {
                    startAt = index;
                }
            });

            const glide = new Glide(x, {
                type: 'slider',       // carousel utan clones
                startAt,
                perView: 3,
                gap: 32,
                breakpoints: {
                    1024: {
                        perView: 2
                    },
                    768: {
                        perView: 1,
                        gap: 16
                    }
                },
                autoplay: 3000,
                rewind: false,          // ingen automatisk loop
                bound: false,            // stoppar clone-slide
                classes: {
                    direction: { ltr: "slideshow--ltr", rtl: "slideshow--rtl" },
                    slider: "slideshow--slider",
                    carousel: "slideshow--carousel",
                    swipeable: "slideshow--swipeable",
                    dragging: "slideshow--dragging",
                    cloneSlide: "slideshow__slide--clone",
                    activeNav: "slideshow__step--active",
                    activeSlide: "slideshow__slide--active",
                    disabledArrow: "slideshow__arrow--disabled",
                }
            });

            function updateTabindex() {
                slides.forEach((slide, i) => {
                    slide.setAttribute('id', slideshowName + "-panel-" + i);
                    slide.setAttribute('aria-labelledby', slideshowName + "-tab-" + i);
                    slide.setAttribute('role', "tabpanel");
                });

                tags.forEach((tag, i) => {
                    tag.setAttribute('aria-selected', i === glide.index ? 'true' : 'false');
                });
            }

            glide.on(['mount.after', 'run'], updateTabindex);
            glide.mount({ Controls, Swipe, Breakpoints });

        });
    });

    window.addEventListener('load', () => {
        Object.values(document.querySelectorAll(".carousel-B")).forEach((x) => {
            const parent = x.closest('.component_content-list');
            const slideshowName = parent?.id;

            const steps = x.querySelectorAll('.slideshow__step');
            const slides = x.querySelectorAll('.slideshow__slide');
            const tags = x.querySelectorAll('.slideshow__tag');

            let startAt = 1;

            steps.forEach((step, index) => {
                if (step.classList.contains('is-start')) {
                    startAt = index;
                }
            });

            const glide = new Glide(x, {
                type: 'slider',       // carousel utan clones
                startAt,
                perView: 1.75,
                gap: 32,
                breakpoints: {
                    768: {
                        perView: 1,
                        gap: 16
                    }
                },
                autoplay: 3000,
                rewind: false,          // ingen automatisk loop
                bound: false,            // stoppar clone-slide
                classes: {
                    direction: { ltr: "slideshow--ltr", rtl: "slideshow--rtl" },
                    slider: "slideshow--slider",
                    carousel: "slideshow--carousel",
                    swipeable: "slideshow--swipeable",
                    dragging: "slideshow--dragging",
                    cloneSlide: "slideshow__slide--clone",
                    activeNav: "slideshow__step--active",
                    activeSlide: "slideshow__slide--active",
                    disabledArrow: "slideshow__arrow--disabled",
                }
            });

            function updateTabindex() {
                slides.forEach((slide, i) => {
                    slide.setAttribute('id', slideshowName + "-panel-" + i);
                    slide.setAttribute('aria-labelledby', slideshowName + "-tab-" + i);
                    slide.setAttribute('role', "tabpanel");
                });

                tags.forEach((tag, i) => {
                    tag.setAttribute('aria-selected', i === glide.index ? 'true' : 'false');
                });
            }

            glide.on(['mount.after', 'run'], updateTabindex);
            glide.mount({ Controls, Swipe, Breakpoints });
        });
    });

    var autoLogin = (window as any).autoLogin;
    if (autoLogin) {
        $.ajax({
            url: autoLogin.myAccountUri,
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (data.authenticated && data.farOnline) {
                    location.href = autoLogin.loginUri;
                }
            }
        });
    }
});

// Exponera jQuery från TypeScript till externa JavaScript-anrop
(window as any).$ = $;
